<template>
  <div class="wrapper">
    <router-view></router-view>
  </div>
</template>

<script>
export default {};
</script>
